export const MAX_ATTENDEES_PER_COURSE = 4;
